import { WarrantySlice } from "slices/warranty/warranty-slice";

export {
  getAllWarrantiesThunk,
  getDefaultWarrantiesThunk,
  deleteBrandModelWarrantyThunk,
} from "slices/warranty/warranty-thunks";

export default WarrantySlice.reducer;
